
<script>
import FeedMessage from "./FeedMessage";
import { api } from "@/api/index";
import { store } from "@/store/index";
import { mapState, mapGetters } from "vuex";
import { baseURL } from "@/api/config.js";

export default {
  mixins: [FeedMessage],

  data() {
    return {
      global: true
    };
  },

  methods: {
    showFile() {
      return `${baseURL}feeds/${this.mess.fed_id}?sid=${localStorage.sid}`;
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/Feed/GlobalFeedMessage.vue